import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { UserEffects } from './users.effects';
import { userFeatureKey } from './users.models';
import { users } from './users.reducer';

@NgModule({
    imports: [SharedModule, StoreModule.forFeature(userFeatureKey, users), EffectsModule.forFeature([UserEffects])],
    exports: [],
    declarations: [],
    providers: [],
})
export class UsersModule {}
